export const FETCH_DIETS_AND_DIET_CATEGORIES = {
  START: 'START_FETCH_DIETS_AND_DIET_CATEGORIES',
  COMPLETE: 'COMPLETE_FETCH_DIETS_AND_DIET_CATEGORIES',
  FAIL: 'FAIL_FETCH_DIETS_AND_DIET_CATEGORIES',
  CLEANUP: 'CLEANUP_FETCH_DIETS_AND_DIET_CATEGORIES',
}

export const ADD_DIET_OR_DIET_CATEGORY_NODE = 'ADD_DIET_OR_DIET_CATEGORY_NODE'

export const RENAME_DIET_OR_DIET_CATEGORY_NODE =
  'RENAME_DIET_OR_DIET_CATEGORY_NODE'

export const RESET_DIETS_AND_DIET_CATEGORIES_TREE =
  'RESET_DIETS_AND_DIET_CATEGORIES_TREE'

export const SET_DATA_FOR_RENAMING_DIET_OR_DIET_CATEGORY_NODE =
  'SET_DATA_FOR_RENAMING_DIET_OR_DIET_CATEGORY_NODE'

export const SET_IS_CURATION_ENABLED_DIET = {
  START: 'START_SET_IS_CURATION_ENABLED_DIET',
  COMPLETE: 'COMPLETE_SET_IS_CURATION_ENABLED_DIET',
  FAIL: 'FAIL_SET_IS_CURATION_ENABLED_DIET',
}

export const DELETE_DIET = {
  START: 'START_DELETE_DIET',
  COMPLETE: 'COMPLETE_DELETE_DIET',
  FAIL: 'FAIL_DELETE_DIET',
}

export const DELETE_DIET_CATEGORY = {
  START: 'START_DELETE_DIET_CATEGORY',
  COMPLETE: 'COMPLETE_DELETE_DIET_CATEGORY',
  FAIL: 'FAIL_DELETE_DIET_CATEGORY',
}
export const MOVE_DIETS = 'MOVE_DIETS'
export const REPLACE_DIET = 'REPLACE_DIET'

export const SAVE_DIETS_AND_DIET_CATEGORIES = {
  START: 'START_SAVE_DIETS_AND_DIET_CATEGORIES',
  COMPLETE: 'COMPLETE_SAVE_DIETS_AND_DIET_CATEGORIES',
  FAIL: 'FAIL_SAVE_DIETS_AND_DIET_CATEGORIES',
}

export const EXPAND_DIET_AND_DIET_CATEGORY_MAIN_TREE_KEYS =
  'EXPAND_DIET_AND_DIET_CATEGORY_MAIN_TREE_KEYS'

export const EXPAND_DIET_AND_DIET_CATEGORY_SUPPORTING_TREE_KEYS =
  'EXPAND_DIET_AND_DIET_CATEGORY_SUPPORTING_TREE_KEYS'
